import { PageMessage } from '../../../../types/PageMessage';
import { SpotAvailabilityMessage } from '../../../../types/SpotAvailabilityMessage';
import {
    CreateSupplierGroupRequestMessage,
    EditSupplierGroupRequestMessage,
    SupplierGroupMessage,
    SupplierGroupTypes,
} from '../../../../types/SupplierGroupMessage';
import {
    SupplierGroupSubscriptionMessage,
    SupplierSubscriptionPlan,
} from '../../../../types/SupplierGroupSubscriptionMessage';
import { authorizedAxiosInstance } from '../instances/AuthorizedAxiosInstance';
import { authorizedGatewayAxiosInstance } from '../instances/AuthorizedGatewayAxiosInstance';
import { nonEmpty } from '../paramUtils';

export interface GetSupplierGroupsParams {
    searchQuery: string;
    page: number;
    types?: SupplierGroupTypes[];
    plans?: SupplierSubscriptionPlan[];
    testCompany?: boolean;
    spotAllowed?: boolean;
}

export const getSupplierGroups = async (
    params: GetSupplierGroupsParams
): Promise<PageMessage<SupplierGroupMessage>> => {
    const response = await authorizedGatewayAxiosInstance.get(`/v1/suppliergroup`, {
        params: {
            searchQuery: params.searchQuery,
            page: params.page,
            types: nonEmpty(params.types),
            plans: nonEmpty(params.plans),
            testCompany: params.testCompany,
            spotAllowed: params.spotAllowed,
        },
    });

    return response.data;
};

export const getSupplierGroup = async (groupId: string): Promise<SupplierGroupMessage> => {
    const response = await authorizedAxiosInstance.get(`/v1/suppliergroup/${groupId}`);

    return response.data;
};

export const createSupplierGroup = async (
    supplierGroup: CreateSupplierGroupRequestMessage
): Promise<SupplierGroupMessage> => {
    const response = await authorizedAxiosInstance.post(`/v1/suppliergroup`, supplierGroup);

    return response.data;
};

export const updateSupplierGroup = async (
    supplierGroup: EditSupplierGroupRequestMessage
): Promise<SupplierGroupMessage> => {
    const response = await authorizedAxiosInstance.put(`/v1/suppliergroup/${supplierGroup.id}`, supplierGroup);

    return response.data;
};

export const uploadSupplierGroupLogo = async (supplierGroupId: string, file: File): Promise<SupplierGroupMessage> => {
    const formData = new FormData();
    formData.append('file', file);

    const response = await authorizedAxiosInstance.post(`/v1/suppliergroup/${supplierGroupId}/logo`, formData);

    return response.data;
};

export const deleteSupplierGroupLogo = async (supplierGroupId: string): Promise<SupplierGroupMessage> => {
    const response = await authorizedAxiosInstance.delete(`/v1/suppliergroup/${supplierGroupId}/logo`);

    return response.data;
};

export const getSpotAvailability = async (
    portCountryCode: string,
    testOrder: boolean
): Promise<SpotAvailabilityMessage> => {
    const response = await authorizedAxiosInstance.get(`/v1/suppliergroup/spot`, {
        params: {
            countryCode: portCountryCode,
            test: testOrder,
        },
    });

    return response.data;
};

export const getSupplierGroupSubscription = async (groupId: string): Promise<SupplierGroupSubscriptionMessage> => {
    const response = await authorizedAxiosInstance.get(`/v1/suppliergroup/${groupId}/subscription`);
    return response.data;
};
